export const GRADIENTS = [
  "linear-gradient(90deg, #be22ff 0%, #ff279c 100%)",
  "linear-gradient(90deg, #ff279c 0%, #ff981f 100%)",
  "linear-gradient(90deg, #ff981f 0%, #be22ff 100%)",
  "linear-gradient(90deg, #be22ff 0%, #ff279c 50%, #ff981f 100%)",
];

export const ANIMATION_SPEED = 2;
